<template>
    <div>
        <headertermsandConditions />
        <div
            class="px-[10px] tablet:px-[20px] desktop:px-[40px] pb-[100px] pt-[115px] tablet:pt-[110px] laptop:pt-[80px] largeDesktop:pt-[120px]">
            <h4 class="tablet:text-[20px] laptop:text-[24px] font-semibold font-poppins text-center text-[#333333]">
                Independent Contractor Agreement</h4>
            <div class="contractoragreementPg min-h-screen pt-[20px] w-full pb-[20px] mt-[20px] font-poppins terms-condition-page !bg-white px-[15px] tablet:px-[20px] shadow-custom rounded-[10px] relative z-10"
            v-html="updateContractorAgreementDetails.terms_and_conditions_text">
            </div>
        </div>
        <div
            class="!absolute bottom-0 left-0 w-full text-center shadow-lg rounded-t-full z-10 flex items-center h-[40px] laptop:h-[50px] justify-center mt-4 mobile:pr-[30px] bg-customBlue-100">
            <p class="select-none tablet:mb-0 mobile:!mb-0 text-white mobile:text-[12px] laptop:text-sm font-roboto">
                Copyright © 2025 MyHappyHome | <a href="/contact-us" class="text-customYellow-100">Contact Us</a>
            </p>
        </div>
    </div>
</template>

<script>
import headertermsandConditions from "../../components/layouts/header/terms-and-conditions-header.vue";
import { mapActions, mapGetters } from "vuex";
export default {
    components: {
        headertermsandConditions,
    },
    computed: {
        ...mapGetters([
            "updateContractorAgreementDetails"
        ]),
    },
    mounted() {
        this.getContractorAgreementDetails()
    },
    methods: {
        ...mapActions([
            "getContractorAgreementDetails"
        ]),
    }
};
</script>
